export interface CreateLead {
  leadOwnerid: string;
  leadSource: string;
  companyName: string;
  firstName: string;
  lastName: string;
  leadEmail: string;
  leadPhone: string;
  leadAddress1: string;
  leadAddress2: string;
  leadCountry: string;
  leadState: string;
  leadCity: string;
  leadZip: string;
  leadStage: string;
}

export interface LeadList {
  companyName: string;
  createdOn: Date | string;
  customer_id: string;
  firstName: string;
  id: string;
  lastName: string;
  leadAddress1: string;
  leadAddress2: string;
  leadCity: string;
  leadCountry: string;
  leadEmail: string;
  leadOwner: string;
  leadPhone: string;
  leadSource: string;
  leadStage: string;
  leadState: string;
  leadZip: string;
  uniqueId: string;
  leadFullName: string;
}

export interface LeadSourceList{
  leadSource: string;
}

export interface LeadDetails {
  activity: any[];
  appointment: AppointmentDetail[];
  budget: string;
  calldetail: LeadCallDetail[];
  companyName: string;
  createdOn: string;
  customer_id: string;
  documents: LeadDocumentDetail[];
  firstName: string;
  id: string;
  lastName: string;
  leadAddress1: string;
  leadAddress2: string;
  leadCity: string;
  leadCountry: string;
  leadEmail: string;
  leadOwner: string;
  leadPhone: string;
  leadSource: string;
  leadStage: string;
  leadState: string;
  leadZip: string;
  uniqueId: string;
}

export interface LeadCallDetail {
  call_date: Date | string;
  call_description: string;
  call_id: string;
  call_time: string;
  call_type: string;
  contact_number: string;
  contact_type: string;
  created_on: Date | string;
  lead_name: string;
  lead_owner: string;
  leadid: string;
  organiser: string;
  reminder_days: string;
  reminder_time: string;
  status: string;
  subject: string;
  zoom_link: string;
  contact_detail: string;
  call_type_detail: string;
}

export interface AddActivity {
  activity_type: string;
  activity_date: string;
  activity_time: string;
  notes: string;
}
export interface LeadAppoinment {
  leadid: string;
  user_id: string;
  usr_role_track_id: string;
  token: string;
  organiser: string;
  leadOwner: string;
  subject: string;
  meeting_date: string;
  meeting_time: string;
  reminder: string;
  location: string;
  description: string;
  aptid?: string;
}
export interface DeleteleadAppoinment {
  leadid: string;
  aptid: string;
}
export interface AppointmentDetail {
  apt_id: string;
  created_on: string;
  description: string;
  lead_owner: string;
  leadid: string;
  location: string;
  meeting_date: string;
  meeting_time: string;
  organiser: string;
  reminder: string;
  status: string;
  subject: string;
}

export interface LeadCallschedule {
  leadid: string;
  user_id: string;
  usr_role_track_id: string;
  token: string;
  organiser: string;
  leadOwner: string;
  subject: string;
  lead_name: string;
  contact_number: string;
  call_type: string;
  zoom_link: string;
  reminder_days: string;
  reminder_time: string;
  call_date: string;
  call_time: string;
  call_description: string;
  contact_type: string;
  callid?: string;
}
export interface DeleteLeadCallschedule {
  leadid: string;
  callid: string;
}
export interface LeadDocumentDetail{
  document_id: any;
  leadid:string;
  file_upload:string;
  created_by:string;
  created_on:string;
  createdby_firstname:string;
  createdby_lastname:string;
  lead_firstname:string;
  lead_lastname:string;
  created_by_name: string;
  lead_by_name: string;
}
export interface DeleteLeadDocument{
  leadid: string;
  documentid: string;
}